var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDislikeActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 6,
    fill: "#7043FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6259 12.0056C28.0956 11.9032 29.1274 13.2269 29.4627 14.6573C29.4646 14.6655 29.4664 14.6737 29.4681 14.682L30.4963 19.8233C30.5063 19.8731 30.5113 19.9238 30.5113 19.9745C30.5113 21.5362 29.2453 22.8022 27.6836 22.8022H25.3701V27.1723C25.3701 28.734 24.1041 30 22.5424 30C20.9807 30 19.7147 28.734 19.7147 27.1723V26.1441C19.7147 24.2984 18.2185 22.8022 16.3728 22.8022H13.2881C12.2943 22.8022 11.4886 21.9966 11.4886 21.0028V13.805C11.4886 12.8112 12.2943 12.0056 13.2881 12.0056H15.3446C16.0292 12.0056 16.6245 12.3879 16.9287 12.9506C17.6057 12.362 18.49 12.0056 19.4576 12.0056H26.6259ZM15.6017 13.805C15.6017 13.663 15.4866 13.548 15.3446 13.548H13.2881C13.1461 13.548 13.031 13.663 13.031 13.805V21.0028C13.031 21.1448 13.1461 21.2599 13.2881 21.2599H15.6017V13.805ZM17.144 21.3204V15.8615C17.144 14.5838 18.1799 13.548 19.4576 13.548H26.6554C26.6772 13.548 26.699 13.547 26.7207 13.5452C27.0594 13.5164 27.6872 13.8571 27.9583 14.9975L28.9672 20.0422C28.932 20.7206 28.3708 21.2599 27.6836 21.2599H24.5989C24.173 21.2599 23.8277 21.6051 23.8277 22.031V27.1723C23.8277 27.8822 23.2522 28.4576 22.5424 28.4576C21.8325 28.4576 21.257 27.8822 21.257 27.1723V26.1441C21.257 23.709 19.4751 21.6901 17.144 21.3204Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislikeActive);
export default __webpack_public_path__ + "static/media/dislikeActive.6205be70ac36ab8876f938a7a6c80794.svg";
export { ForwardRef as ReactComponent };